<div class='context-menu' cdkMenu>
  @for (menuItem of menuItems; track menuItem) {
    <div class='context-menu-item-host'>
      <button class='menu-item'
        (click)='menuItem.action()'
        cdkMenuItem>
        @if (menuItem.icon) {
          <mat-icon [svgIcon]='menuItem.icon'></mat-icon>
        }
        <span>{{ menuItem.label }}</span>
      </button>
    </div>
  }
</div>
